import request from '@/api/request'
import * as R from 'ramda'
import to from 'await-to-js'
import { useAuthStore } from '@/store/authStore'
import { ChannelCode, ProductCode } from '@/utils/constant'

/**
 * 查询被保险人信息
 * @param insuredUserName 被保险人名称
 * @returns
 */
export const fetchInsuredUserHistory = async (
  name: string,
  channelCode?: ChannelCode,
  orderType?: number,
): Promise<DataResponse<any>> => {
  return await request.get(
    '/saas-insurance/insures/queries/insuredUserHistory',
    {
      params: {
        insuredUserName: name,
        channelCode,
        orderType,
      },
    },
  )
}

/**
 * 查询海管家字典
 * @param
 * @returns
 */
export const fetchHgjDictResult = async ({
  channelCode,
  productCode,
}: {
  channelCode: string
  productCode?: ProductCode
}): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/insures/hgj/dictResult`, {
    params: {
      channelCode,
      productCode,
    },
  })
}

/**
 * 查询保险公司信息
 * @returns
 */
export const fetchInsuranceCompanyInfo = async (): Promise<
  DataResponse<any>
> => {
  return await request.get(`/saas-insurance/insures/hgj/insurance-company-info`)
}

/**
 * 条款查询
 * @param
 * @returns
 */
export const fetchClause = async (params: any): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/insures/hgj/clause`, {
    params,
  })
}

/**
 * 免赔查询
 * @param
 * @returns
 */
export const fetchPolicyInfo = async (data: any) => {
  const info = R.clone(
    Object.assign({}, data, { addClauseIds: data.addClauseIds.join(',') }),
  )
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/policyInfo',
    info,
  )
}

/**
 * 保费查询
 * @param
 * @returns
 */
export const fetchPremiumResult = async (data: any) => {
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/premiumResult',
    data,
  )
}

/**
 * 保存草稿
 * @param
 * @returns
 */
export const saveHgjDraft = async (data: any) => {
  return await request.post<any, any>('/saas-insurance/insures/hgj/draft', data)
}

/**
 * 告知书查询
 * @param
 * @returns
 */
export const fetchAgreement = async (
  params: any,
): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/insures/hgj/agreement`, {
    params,
  })
}

/**
 * 校验发送数据
 * @param
 * @returns
 */
export const checkHgjParam = async (data: any) => {
  data.frClauseContent = data.frClauseContent.replace(/\n/g, '')
  data.insureRemark = data.insureRemark.replace(/\n/g, '')
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/checkParam',
    data,
  )
}
/**
 * 校验批改的发送数据
 */
export const checkHgjParamCorrect = async (data: any) => {
  data.frClauseContent = data.frClauseContent.replace(/\n/g, '')
  data.insureRemark = data.insureRemark.replace(/\n/g, '')
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/checkEditParam',
    data,
  )
}
/**
 * 保险批改
 * @param
 * @returns
 */
export const policyEditCorrect = async (data: any) => {
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/policyEdit',
    data,
    {
      baseURL:
        import.meta.env.VITE_NAS_BASE_URL || import.meta.env.VITE_BASE_URL,
    },
  )
}
/**
 * 提交保险
 * @param
 * @returns
 */
export const applySure = async (data: any) => {
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/applySure',
    data,
    {
      baseURL:
        import.meta.env.VITE_NAS_BASE_URL || import.meta.env.VITE_BASE_URL,
    },
  )
}

/**
 * 告知查询(强制阅读)
 * @param
 * @returns
 */
export const fetchInform = async (params: any): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/insures/hgj/inform`, {
    params,
  })
}

/**
 * 批改
 * @param
 * @returns
 */
export const policyEdit = async (data: any) => {
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/policyEdit',
    data,
    {
      baseURL:
        import.meta.env.VITE_NAS_BASE_URL || import.meta.env.VITE_BASE_URL,
    },
  )
}

/**
 * 后台跳转线上编辑保存
 * @param data
 * @returns
 */
export const saveBackstageOnlineEdit = async (data: any) => {
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/online-edit',
    data,
    {
      baseURL:
        import.meta.env.VITE_NAS_BASE_URL || import.meta.env.VITE_BASE_URL,
    },
  )
}

/**
 * 保险详情查询
 * @param
 * @returns
 */
export const fetchHgjDetail = async (
  id: string,
): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/insures/hgj/detail?id=${id}`)
}

/**
 * 保险详情复制
 * @param
 * @returns
 */
export const fetchHgjCopyDetail = async (
  id: string,
): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/insures/hgj/copy?id=${id}`)
}

/**
 * 保单预览
 * @param
 * @returns
 */
export const insurancePreview = async (data: any) => {
  return await request.post<any, any>(
    '/saas-insurance/insures/hgj/insurance-preview',
    data,
  )
}

/**
 * 保单预览(列表)
 * @param
 * @returns
 */
export const insurancePreviewList = async (id: string) => {
  return await request.get<any, any>(
    `/saas-insurance/insures/hgj/insurance-preview/${id}`,
  )
}

/**
 * 编辑按钮-校验数据
 * @param id 订单id
 * @returns
 */
export const fetchCheckEditOrder = async (id: string) => {
  return await request.get<any, any>(
    `/saas-insurance/insures/hgj/edit-order/check/${id}`,
  )
}

/**
 * 保存草稿-新版
 * @param
 * @returns
 */
export const saveDraft = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/draft-process/${data.channelCode || ''}`,
      data,
    ),
  )
}

/**
 * 保费查询-新版
 * @param
 * @returns
 */
export const fetchPremium = async (data: any) => {
  const authStore = useAuthStore()
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/premium-process/${data.channelCode || authStore.traditionalHgjChannelVOS[0]?.channelCode}`,
      data,
    ),
  )
}

/**
 * 投保接口(预消费)
 * @param
 * @returns
 */
export const fetchPreConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/preConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 批改接口(预消费)
 * @param
 * @returns
 */
export const fetchEditPreConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/edit/preConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 批改接口(确认消费)
 * @param
 * @returns
 */
export const fetchEditConfirmConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/edit/confirmConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 投保接口(确认消费)
 * @param
 * @returns
 */
export const fetchConfirmConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/confirmConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 跨境批量投保接口（预消费）
 */
export const fetchCrossBatchPreConsume = async (data: {
  channelCode: string
  orderIds: string[]
}) => {
  const { channelCode, ...payload } = data
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/cross/batch-preConsume/${channelCode}`,
      payload,
    ),
  )
}

/**
 * 跨境批量投保接口（确认消费）
 */
export const fetchCrossBatchConfirmConsume = async (data: {
  channelCode: string
  preConsumeId: string
  payOrderNo: string
  confirmConsumeInfo: Record<string, any>
  payType: number
}) => {
  const { channelCode, ...payload } = data
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/cross/batch-confirmConsume/${channelCode}`,
      payload,
    ),
  )
}

/**
 * 跨境货运险保险方案下拉选项
 */
export interface CrossInsurancePlanOption {
  planName: string
  /** 是否热门(0:否, 1:是) */
  isHot: number
  /** 是否推荐(0:否, 1:是) */
  isRecommend: number
}

/**
 * 查询跨境货运险保险方案名称
 */
export const fetchCrossInsurancePlanNames = async (params: {
  channelCode: string
  productCode: string
  businessType: string
  cargoType: string
}): Promise<DataResponse<CrossInsurancePlanOption[]>> => {
  const { channelCode, ...query } = params
  return await request.get(
    `/saas-insurance/direct/cross/insurance-plan-names/${channelCode}`,
    { params: query },
  )
}

/**
 * 保存跨境货运险草稿
 */
export const saveCrossDraft = async (data: any) => {
  return await to(
    request.post<any, DataResponse<string>>(
      `/saas-insurance/direct/cross/draft-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 跨境货运险保费试算
 */
export const fetchCrossPremium = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/cross/premium-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 跨境货运险投保预消费
 */
export const fetchCrossPreConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/cross/preConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 跨境货运险投保确认消费
 */
export const fetchCrossConfirmConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/cross/confirmConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 跨境货运险批改预消费
 */
export const fetchCrossEditPreConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/cross/edit/preConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 跨境货运险批改确认消费
 */
export const fetchCrossEditConfirmConsume = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/cross/edit/confirmConsume-process/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 投保接口(见费出单投保)
 * @param
 * @returns
 */
export const fetchOrderAfterQuote = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/cash/before/policy/approval/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 批改接口(见费出单批改)
 * @param
 * @returns
 */
export const fetchEditOrderAfterQuote = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/cash/before/policy/endorse/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 见费出单-支付接口
 */
export const fetchOrderAfterQuotePayment = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/cash/before/policy/payment/${data.channelCode}`,
      data,
    ),
  )
}

/**
 * 投保接口(rrweb)
 * @param id
 * @param rrcode
 * @returns
 */
export const fetchRrweb = async (data: any) => {
  return await to(
    request.post<any, any>(`/saas-insurance/direct/hgj/rrweb`, data, {
      baseURL:
        import.meta.env.VITE_NAS_BASE_URL || import.meta.env.VITE_BASE_URL,
    }),
  )
}

/**
 * 检查用户是否签署代投保协议
 * @returns
 */
export const fetchCheckAgreementStatus = async () => {
  return await to(
    request.get<any, any>(`/saas-insurance/users/insurance-agreement-confirm`),
  )
}

/**
 * 签署代投保协议
 * @param data 签署信息和rrweb数据
 * @returns
 */
export const fetchSignAgreement = async (data: any) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/users/insurance-agreement-confirm/confirm`,
      data,
      {
        baseURL:
          import.meta.env.VITE_NAS_BASE_URL || import.meta.env.VITE_BASE_URL,
      },
    ),
  )
}

/**
 * 获取代投保协议内容
 * @returns
 */
export const fetchAgreementContent = async () => {
  return await to(
    request.get<any, any>(`/saas-insurance/direct/hgj/agreement/content`),
  )
}

/**
 * 查询船舶信息
 * @param
 * @returns
 */
export const fetchShipInfo = async (params: any) => {
  return await to(
    request.get<any, any>(`/saas-insurance/direct/hgj/ship`, {
      params,
    }),
  )
}

/**
 * 查询船期信息
 * @param data 船名、航次
 * @returns
 */
export const fetchVesselSchedule = async (data: {
  vesselName: string
  voyage?: string
  carrierCode?: string
}) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/clients/freightower/vessel/schedule`,
      data,
    ),
  )
}

/**
 * 不索赔保函预览
 * @param channelCode 保司通道
 * @returns
 */
export const fetchNoClaimGuaranteePreview = async (channelCode: string) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/clients/freightower/guarantee-letter/preview`,
      {
        channelCode,
      },
    ),
  )
}

/**
 * 查询企业信息
 * @param params 企业名称
 * @returns
 */
export const fetchCompanyInfo = async (data: { companyName: string }) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/insures/hgj/enterprise-information`,
      data,
    ),
  )
}

/**
 * 查询查勘代理人
 * @param channelCode 渠道代码
 * @param data 查询参数
 * @returns
 */
export const fetchSurveyAgent = async (
  channelCode: string,
  data: {
    dcountryCode?: string
    dportCode?: string
    productCode: string
  },
) => {
  return await to(
    request.post<any, any>(
      `/saas-insurance/direct/hgj/query/survey-agent/${channelCode}`,
      data,
    ),
  )
}

/**
 * 下载保单
 * @param
 * @returns
 */
export const fetchPolicyURL = async (params: any) => {
  return await to(
    request.get<any, any>(`/saas-insurance/direct/hgj/policyURL`, {
      params,
    }),
  )
}

/**
 * 查询海币和券数量
 */
export const fetchWalletDetail = async () => {
  return await to(request.get<any, any>(`/saas-insurance/wallet/detail`))
}

/**
 * 模糊查询代投保企业列表
 * @param data 查询参数
 * @returns
 */
export const fetchProxyEnterpriseList = async (params: { keyword: string }) => {
  return await to(
    request.get<any, any>(`/saas-insurance/users/enterprise`, {
      params,
    }),
  )
}

/**
 * AI识别货物类型
 * @param content 货物名称
 * @returns
 */
export const recognizeCargoByAi = async (data: { content: string }) => {
  return await request.post<any, any>(
    '/saas-insurance/insures/ai/cargo/recognize',
    data,
  )
}
